import axios from 'axios';
import { notifyError } from 'config/setupBugsnag';
import RestUtility from '../../../restUtility';
import { ScannerConfig, ServiceOptions } from '../../../server/types';

export class IteroProductService {
  private restUtility: RestUtility;

  constructor() {
    this.restUtility = new RestUtility();
  }

  async getScannerConfigurations(contactId: string, sku: string) {
    try {
      const data = await axios.post(
        `/getScannerDetailsBySKU?sku=${sku}&contactId=${contactId}`
      );

      //@ts-ignore
      const configOptions =
        data.data.Record.iTeroPrdDetails[0].attributeDetails;

      const currency = data.data.Record.iTeroPrdDetails[0].currencyCode;
      const scannerOptions: ScannerConfig[] = [];

      //@ts-ignore
      configOptions.forEach(config => {
        //@ts-ignore
        const serviceOptions: ServiceOptions[] = [];
        //@ts-ignore
        config.servFeeWithPrice.forEach(service => {
          const period = service.split(',')[0].split(':')[1];
          const price = service.split(',')[1].split(':')[1];
          let CurrencyFormat = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency,
          });
          serviceOptions.push({
            period,
            displayPrice: CurrencyFormat.format(price),
            price,
            periodWithPrice: `${period} - ${CurrencyFormat.format(price)}`,
          });
        });
        scannerOptions.push({
          scannerType: config.scannerType,
          //@ts-ignore
          serviceOptions: serviceOptions,
        });
      });

      //@ts-ignore
      console.log('scannerOptions', scannerOptions);
      //@ts-ignore
      return scannerOptions;
    } catch (error) {
      notifyError('ApiError:: createProject', error);
      throw error;
    }
  }
}
